import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-banner">
        <h1 className="privacy-title">PRIVACY AND POLICY</h1>
      </div>

      <div className="privacy-content">
        <p className="privacy-text">
          WireOx LLC ("WireOx", "we", "our", or "us") takes the privacy of our
          customers, business partners, and website visitors seriously. This
          Privacy Policy describes how we collect, use, store, and protect your
          personal information when you visit www.wireox.com or conduct
          business with us. By using our website or services, you agree to the
          practices described in this policy. If you do not agree, please
          discontinue use of our site.
        </p>

        <h2 className="section-heading">INFORMATION WE COLLECT</h2>
        <p className="privacy-text">
          We may collect the following types of personal information:
        </p>
        <ul className="privacy-list">
          <li>
            Information you provide directly: your name, business name, email
            address, phone number, billing and shipping addresses, Federal Tax
            ID/EIN, and payment details submitted through our website, account
            application, order forms, or customer support inquiries.
          </li>
          <li>
            Information collected automatically: when you visit our website, we
            may automatically collect your IP address, browser type, operating
            system, referring URLs, pages visited, and time spent on pages.
            This is collected through cookies and similar tracking
            technologies.
          </li>
        </ul>

        <h2 className="section-heading">HOW WE USE YOUR INFORMATION</h2>
        <p className="privacy-text">
          We use your personal information to:
        </p>
        <ul className="privacy-list">
          <li>Process and fulfill wholesale orders and manage your account</li>
          <li>Send invoices, order confirmations, and shipping notifications</li>
          <li>Respond to customer service inquiries</li>
          <li>Improve our website, platform, and product offerings</li>
          <li>
            Send promotional communications about WireOx products (with your
            consent)
          </li>
          <li>Comply with legal obligations and enforce our Terms & Conditions</li>
        </ul>

        <h2 className="section-heading">COOKIES AND TRACKING</h2>
        <p className="privacy-text">
          Our website uses cookies - small text files stored on your device -
          to improve your browsing experience, remember your preferences, and
          gather anonymized analytics data. You may disable cookies through
          your browser settings; however, some features of our site may not
          function correctly without them. We do not use cookies to collect
          sensitive personal or financial information.
        </p>

        <h2 className="section-heading">SHARING OF INFORMATION</h2>
        <p className="privacy-text">
          WireOx does not sell or rent your personal information to third
          parties. We may share your information only in the following limited
          circumstances:
        </p>
        <ul className="privacy-list">
          <li>
            With service providers who assist us in operating our website,
            processing orders, or delivering communications (subject to
            confidentiality agreements)
          </li>
          <li>When required by law, court order, or regulatory authority</li>
          <li>
            In connection with a business merger, acquisition, or sale of
            assets, with appropriate notice to you
          </li>
        </ul>

        <h2 className="section-heading">DATA RETENTION AND SECURITY</h2>
        <p className="privacy-text">
          We retain your personal information for as long as necessary to
          fulfill the purposes described in this policy, maintain business
          records, or comply with applicable legal obligations. We implement
          commercially reasonable administrative, technical, and physical
          safeguards to protect your information from unauthorized access,
          disclosure, or loss. However, no method of transmission over the
          internet is 100% secure.
        </p>

        <h2 className="section-heading">YOUR PRIVACY RIGHTS</h2>
        <p className="privacy-text">
          Depending on your location, you may have the right to:
        </p>
        <ul className="privacy-list">
          <li>Access the personal information we hold about you</li>
          <li>Request correction of inaccurate data</li>
          <li>
            Request deletion of your personal information (subject to legal
            retention requirements)
          </li>
          <li>Opt out of marketing communications at any time</li>
          <li>
            For California residents: the right to know, delete, and opt out of
            the sale of personal information under the CCPA
          </li>
        </ul>
        <p className="privacy-text">
          To exercise any of these rights, contact us at privacy@wireox.com.
        </p>

        <h2 className="section-heading">CHILDREN&apos;S PRIVACY</h2>
        <p className="privacy-text">
          Our website and services are intended for business use by adults aged
          18 and older. WireOx does not knowingly collect personal information
          from individuals under the age of 18. If we become aware that we have
          inadvertently collected such information, we will delete it promptly.
          If you believe a minor has submitted personal information to us,
          please contact us immediately.
        </p>

        <h2 className="section-heading">POLICY UPDATES</h2>
        <p className="privacy-text">
          WireOx reserves the right to update this Privacy Policy at any time.
          When we do, we will revise the Last Updated date at the top of this
          page. We encourage you to review this policy periodically. Continued
          use of our website following any updates constitutes your acceptance
          of the revised terms.
        </p>

        <h2 className="section-heading">CONTACT US</h2>
        <p className="privacy-text">
          For questions, concerns, or requests related to this Privacy Policy
          or your personal information, please contact:
          <br />
          WireOx LLC
          <br />
          Privacy Inquiries: privacy@wireox.com
          <br />
          Website: www.wireox.com
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
